import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import { ErrorBoundary } from "../components/error_boundary.js";
import { Tooltip } from "./common_metadata.js";
import React from "react";

interface GanttProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: GanttState;
    settings: any;
}

export class GanttComponent extends React.Component<GanttProps, any>{
    public static get NAME(): string { return "GANTT"; }
    private ganttRef;
    private gantt;
    private ganttStateWrapper: GanttState;

    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.ganttStateWrapper = new GanttState();
        this.ganttStateWrapper.hydrateFromJS(props.settings);
    }

    getTemplate = (task, templateString: string) => {
        try {
            var template = kendo.template(templateString);
            let templateData: any = { row: task, context: this.props.context.variables }
            var result = template(templateData);
        }
        catch (e) {
            return '<div style = "color:red">Error im template:' + e.message + '</div>';
        }
        return result
    }

    handleDataChanged = (allData) => {
        if (this.ganttStateWrapper.dataSource) {
            let result = allData[this.ganttStateWrapper.dataSource.getDataSourceIdentifier() + this.props.uid];
            if (!result) {
                result = allData[this.ganttStateWrapper.dataSource.getDataSourceIdentifier()];
            }

            //HACK
            if (result && result.Data) {

                for (let b of result.Data) {
                    b.id = Math.abs(this.hash(b.ID));
                    b.parentId = b.PARENTID ? Math.abs(this.hash(b.PARENTID)) : null;
                    b.title = b.TITLE;
                    b.start = new Date(b.START);
                    b.end = new Date(b.END);
                    b.summary = b.SUMMARY == 1;
                    b.orderId = b.ORDERID;
                    b.expanded = true;

                    b.START = b.start;
                    b.END = b.end;
                }
                this.gantt.dataSource.data(result.Data);
            }
        }
    }
    hash = (str) => {
        var res = 0,
            len = str.length;
        for (var i = 0; i < len; i++) {
            res = res * 31 + str.charCodeAt(i);
        }
        return res;
    }

    registerComponent = (uid: string, services: string[], datasources: datasources.Datasource[]) => {
        this.props.context.registerComponent(uid, services, this.handleDataChanged, null, datasources);
    }

    UNSAFE_componentWillMount() {
        this.registerComponent(this.props.uid, null, [this.ganttStateWrapper.dataSource]);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.metadataSettings != prevProps.settings || this.state.metaData != prevState.metaData || this.state.visibleValues != prevState.visibleValues) {
            this.gantt.setOptions(this.createGanttSettings());

        }
        else if (this.state.visibleValues != prevState.visibleValues) {
            this.gantt.dataSource.data(this.state.visibleValues);
        }
    }

    createColumn = (c: Column) => {
        let newColumn: any = { field: c.columnName, title: c.title, width: c.width ? Number(c.width) : 60, format: '{0:' + c.format + '}' };
        return newColumn;
    }

    createGanttSettings = () => {
        let config: any = {
            editable: false,
            views: [
                {
                    type: this.ganttStateWrapper.view ? this.ganttStateWrapper.view : "week", selected: true
                }],
            height: this.ganttStateWrapper.height ? this.ganttStateWrapper.height : 700,
            showWorkHours: false,
            showWorkDays: false,
            snap: false
        };

        if (this.ganttStateWrapper.rowHeight) {
            config.rowHeight = Number(this.ganttStateWrapper.rowHeight);
        }

        if (this.ganttStateWrapper.columns && this.ganttStateWrapper.columns.length > 0) {
            config.columns = this.ganttStateWrapper.columns.map((c: Column) => { return this.createColumn(c) })
        }

        if (this.ganttStateWrapper.taskTemplate) {
            config.taskTemplate = (task) => this.getTemplate(task, this.ganttStateWrapper.taskTemplate)
        }
        config.tooltip = { visible: false, template: null };

        if (this.ganttStateWrapper.tooltip && this.ganttStateWrapper.tooltip.visible) {
            config.tooltip.visible = true;
            config.tooltip.template = this.ganttStateWrapper.tooltip.template ? (task) => this.getTemplate(task.task, this.ganttStateWrapper.tooltip.template) : null
        }
        return config;
    }

    componentDidMount() {
        var $rootNode = $(this.ganttRef);
        const config = this.createGanttSettings();
        this.gantt = $rootNode.kendoGantt(config).data("kendoGantt");
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const oldDataSourceId = !this.ganttStateWrapper.dataSource ? null : this.ganttStateWrapper.dataSource.getDataSourceIdentifier();

        this.ganttStateWrapper.hydrateFromJS(nextProps.settings);

        if (this.ganttStateWrapper.dataSource && this.ganttStateWrapper.dataSource.getDataSourceIdentifier() != oldDataSourceId) {

            this.registerComponent(nextProps.uid, null, [this.ganttStateWrapper.dataSource]);
            this.props.context.loadMissingData(this.props.queryParameter);
        }
    }

    componentWillUnmount() {
        this.props.context.unregisterComponent(this.props.uid);
    }
    render() {
        var value: any = '-.-';
        var text: any = '-.-';
        if (this.state.value) {
            value = [this.state.value[this.props.settings.valueField]];
            text = this.props.settings.textField;
        }

        let customStyle = this.ganttStateWrapper.customStyle ? <style>{this.ganttStateWrapper.customStyle}</style> : null;

        return <react_components.ReactColumn width={this.props.metadataSettings.width}>
            <ErrorBoundary>
                {customStyle}
                <div ref={(e) => this.ganttRef = e}></div>
            </ErrorBoundary>
        </react_components.ReactColumn>
    }
};


export class GanttState extends propertyTypes.BaseComponentProps {
    private heightMetadata = new propertyTypes.TextProperty("height", "Height");
    public height: string;

    private rowHeightMetadata = new propertyTypes.TextProperty("rowHeight", "Row height");
    public rowHeight: string;

    private templateMetadata = new propertyTypes.TemplateProperty("taskTemplate", "Task template");
    public taskTemplate: string;

    private customStyleMetadata = new propertyTypes.TemplateProperty("customStyle", "Custom style");
    public customStyle: string;

    private columnsMetadata = new propertyTypes.ObjectListPropertyExt("columns", "Columns")
        .addStateImplementation("default", Column)
    public columns: (Column)[];

    private tooltipMetadata = new propertyTypes.ObjectPropertyExt("tooltip", "Tooltip")
        .addStateImplementation("default", Tooltip)
    public tooltip: (Tooltip);

    private viewMetadata = new propertyTypes.SelectProperty("view", "View").addOption("day", "Day").addOption("week", "Week").addOption("month", "Month").addOption("year", "Year");
    public view: string;

    public dataSource: datasources.Datasource;

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.templateMetadataAll = baseMetaData.concat([this.heightMetadata, this.rowHeightMetadata, this.templateMetadata, this.tooltipMetadata, datasources.dataSourceMetadata, this.columnsMetadata, this.customStyleMetadata, this.viewMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateMetadataAll;
    }
}

class Column extends propertyTypes.Serializable {
    private columnMetadata: propertyTypes.BaseProperty[];

    private columnNameMetadata = new propertyTypes.ColumnProperty("columnName", "Column name", "dataSource")
    public columnName: string;

    private titleMetadata = new propertyTypes.TranslatableTextProperty("title", "Title")
    public title: string;

    private formatMetadata = new propertyTypes.TextProperty("format", "Format");
    public format: string;

    private widthMetadata = new propertyTypes.TextProperty("width", "Width");
    public width: string;

    constructor() {
        super();
        this.columnMetadata = [this.columnNameMetadata, this.titleMetadata, this.formatMetadata, this.widthMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.columnMetadata;
    }
}